'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

require('./Overlay.scss');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Overlay = function Overlay(_ref) {
    var children = _ref.children;
    return _react2.default.createElement(
        'div',
        { className: 'Overlay' },
        children
    );
};

// Styles
// Lib


Overlay.propTypes = {
    children: _propTypes2.default.oneOfType([_propTypes2.default.arrayOf(_propTypes2.default.node), _propTypes2.default.node])
};

exports.default = Overlay;


//////////////////
// WEBPACK FOOTER
// ./src/client/components/misc/Overlay.js
// module id = 711
// module chunks = 0